const MinusIcon = ({
  color = "var(--grey900)",
  size = 24,
  onClick = () => {},
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <rect x="0.5" width="32" height="32" rx="16" fill={color} />
      <g clipPath="url(#clip0_2896_36912)">
        <path
          d="M9.5 16H23.5"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2896_36912">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(4.5 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MinusIcon;
